angular.module('bmsApp.dashboard')
	.controller('DashboardTodayCtrl', function ($scope,
												$rootScope,
												$state,
												$q,
												$timeout,
												$ngBootbox,
												LiveStreamSvc,
												EmployeeOptionsSvc,
												EmployeeSvc,
												PhotoSvc,
												uiGmapGoogleMapApi,
												uiGmapIsReady,
												LoneWorkerPingSvc,
												$filter
	) {
		var self = this;

		function init() {
			// self.interval = 5000;
			self.interval = 120000;
			self.liveStreams = [];
			self.liveStreamParams = {
				filter: {
					today: true,
					after: '',
					currentDate: '',
				},
				sorting: {
					date: 'asc'
				}
			};
			self.employeeOptionsParams = {
				filter: {
					status: true,
					hasUserAccount: true
				}
			};

			self.loadingLiveStreams = true;
			self.loadingEmployees = true;
			self.methods.fetchLiveStreams();
			setInterval(function(){
				self.liveStreamParams.filter.today = false;
				// self.methods.fetchLiveStreams();
				self.methods.fetchEmployees();
				self.methods.loadMap();
			}, self.interval);
			startFetchingLiveStreams();
			// Live (1 min): 1000 * 60
			self.methods.fetchEmployees();
			var promises = {
				employeeOptionsRes: EmployeeOptionsSvc.employee(self.employeeOptionsParams)
			};

			$q.all(promises)
				.then(function (responses) {
					self.employeeOptions = responses.employeeOptionsRes.data.options;
					self.loading = false;
				});
			self.visitableActivities = [
				'completed-risk-assessment',
				'completed-material-test',
				'completed-rug-cleaning-report',
				'completed-sat-note',
				'customer-refused-sat-note',
				'additional-work-added',
				'payment-saved',
				'payment-refused',
				'started-job',
				'completed-job',
				'complaint-raised',
				'completed-customer-disclaimer',
				'customer-refused-disclaimer',
				'complaint-raised',
				'sent-sms-to-customer',
				'job-not-going',
				'completed-time-log-entry',
				'completed-final-check',
			];
			self.photoableActivities = [
				'van-before-photo-taken',
				'job-before-photo-taken',
				'job-after-photo-taken',
				'van-after-photo-taken',
			];
			self.alertableActivities = [
				'payment-refused',
				'customer-refused-disclaimer',
				'customer-refused-sat-note',
				'complaint-raised',
			];
		}
		//FOR NOT TO BE SELECT FUTURE DATE
		self.dateConfig = angular.copy($scope.config.datePicker.basic);
		self.dateConfig.options.maxDate = moment()

		$scope.changeDate = function(date){
			self.loadingLiveStreams = true;
			self.liveStreamParams = {
				filter: {
					today: false,
					currentDate: date,
					after: ''
				}
			}
			if(date == moment().format('YYYY-MM-DD')){
				self.methods.fetchLiveStreams(true);
				startFetchingLiveStreams();
			}else {
				self.methods.fetchLiveStreams(true);
				clearInterval(self.currentTimeOut);
			}
		}

		function startFetchingLiveStreams() {
			self.currentTimeOut =
			setInterval(function(){
				self.liveStreamParams.filter.today = false;
				self.methods.fetchLiveStreams(false);
			}, self.interval);
		}

		function fetchLiveStreams(clearAll) {
			if(clearAll == true){
				self.liveStreams = [];
			}
			LiveStreamSvc.index(self.liveStreamParams).then(function (response){
				angular.forEach(response.data.live_stream_collection, function(liveStream){
					self.liveStreams.unshift(liveStream);
				})
				self.liveStreamParams.filter.after = moment().format('YYYY-MM-DD HH:mm:ss');
				self.loadingLiveStreams = false;
			});
		}

		function fetchEmployees() {
			EmployeeOptionsSvc.employee({filter: {status: true, appEnabled: true}, withWorkLog: true}).then(function (response){
				self.employees = response.data.options;
				angular.forEach(self.employees, function(employee){
					employee.mobile_display_last_check_in_at = moment(employee.mobile_display_last_check_in_at);
				})
				self.loadingEmployees = false;
			});

		}

		function onLiveStreamEmployeeChanged() {
			self.loadingLiveStreams = true;
			self.liveStreams = [];
			self.liveStreamParams.filter.after = '';
			fetchLiveStreams();
		}

		function onTheyAreOkClicked(employee) {
			employee.mobile_display_last_check_in_at = moment().add(2,'hours');
			console.log(employee.mobile_display_last_check_in_at);
			let params = {
				mobile_display_last_check_in_at: employee.mobile_display_last_check_in_at.format('YYYY-MM-DD HH:mm'),
				employee: { id: employee.id}
			};

			return EmployeeSvc.safe(params)
				.then(function (response) {
					console.log(response.data);
				});
		}

		function getMomentDate(dateString){
			return moment(dateString);
		}

		$scope.viewPhoto = function(title, photo) {
			PhotoSvc.showViewModal(title, photo);
		};


		$scope.loadingMap = true;
		$scope.pingMarkers = [];
		$scope.selectedMarker = null;
		$scope.pings = [];
		$scope.closeClick = function(){
			$scope.selectedMarker = null;
			$scope.windowOptions.show = false;
		}
		$scope.markers = {
			options: {
				// anchorPoint: {
				// 	x:300,
				// 	y:500
				// },
			},
			events: {
				click: function (evt) {
					$scope.selectedMarker = evt.model;

					// find clicked ping
					var id = evt.model.id;
					var pings = $filter('filter')($scope.pingMarkers, {
						id: id
					}, true);

					angular.extend($scope.selectedMarker, {
						employee: pings[0].employee,
						ping_date: pings[0].ping_date.length > 10 ? moment(pings[0].ping_date).format('hh:m a') : pings[0].ping_date,
					});
					$scope.windowOptions.show = true;
				}
			}
		};

		$scope.infoOptions = {
			pixelOffset: {
				width: 0,
				height: -40,
			}
		}
		$scope.windowOptions = {
			show: false
		};

		$scope.control = {};
		uiGmapIsReady.promise().then(function () {
			self.methods.loadMap();
		});

		uiGmapGoogleMapApi.then(function (map) {
			$scope.map = {
				center: {
					latitude: 52,
					longitude: -1.0
				},
				zoom: 8,
				options: {
					panControlOptions: {
						position: map.ControlPosition.RIGHT_TOP
					},
					zoomControlOptions: {
						position: map.ControlPosition.RIGHT_TOP
					},
					mapTypeControlOptions: {
						position: map.ControlPosition.RIGHT_BOTTOM
					}
				},
				events: {
				}
			};
		});

		var params = {
			filter: {
				RecentInHours: 2,
				GroupBy: 'employee_id'
			}
		};

		function loadMap(){
			LoneWorkerPingSvc.lastCheckIns(params)
				.then(function (response) {
					var pings = response.data.lone_worker_ping_collection;
					var bounds = new google.maps.LatLngBounds();
					// Put the markers into a custom object for google maps
					$scope.pingMarkers = [];
					angular.forEach(pings, function (ping) {
						$scope.pingMarkers.push({
							id: ping.id,
							geo: {
								latitude: ping.lat,
								longitude: ping.long
							},
							iconUrl: 'images/icons/truck.png',
							employee: ping.employee,
							ping_date: ping.ping_date,
						});
						var point = new google.maps.LatLng(ping.lat, ping.long);
						bounds.extend(point);
						ping.geocoded = true;
						$scope.pings.push(angular.copy(ping));
					});

					$scope.control.getGMap().fitBounds(bounds);
					$scope.loadingMap = false;
				});
		}

		self.methods = {
			init: init,
			fetchLiveStreams: fetchLiveStreams,
			fetchEmployees: fetchEmployees,
			onLiveStreamEmployeeChanged: onLiveStreamEmployeeChanged,
			onTheyAreOkClicked: onTheyAreOkClicked,
			getMomentDate: getMomentDate,
			loadMap: loadMap,
		};

	});
